import Rete from 'rete'

import OtnSingleTemplate from './OtnSingleTemplate'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

export default class OtnSingleComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.OTN_SINGLE)
    
    this.data.component = OtnSingleTemplate
    this.socket = config ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
  }

  builder(node) {
    node.lingualName = lingualName.OTN_SINGLE
    this.setConnection()
    
    const otnSingleInput = new Rete.Input(CONST_SOCKET.OTN_SINGLE_INPUT, lang.otn_single_socket_input_reply, this.socket.otnSingleInput, false)
    const otnSingleOutput = new Rete.Output(CONST_SOCKET.OTN_SINGLE_OUTPUT, lang.otn_single_socket_output_next, this.socket.otnSingleOutput, false)
    
    node.addInput(otnSingleInput)
    node.addOutput(otnSingleOutput)
    
    if (this.isSequenceAddonAvailable) {
      const otnSingleOutputSequence = new Rete.Output(
        CONST_SOCKET.OTN_SINGLE_OUTPUT_SEQUENCE, 
        lang.otn_single_socket_output_next_sequence, 
        this.socket.otnSingleOutputSequence, 
        false
      )

      node.addOutput(otnSingleOutputSequence)
    }

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.OTN_SINGLE_OUTPUT] = node.data
  }

  setConnection() {
    // OTN may be connected to:
    this.socket.otnSingleOutput.combineWith(this.socket.newPostbackInput)
    
    if (this.isSequenceAddonAvailable) {
      this.socket.otnSingleOutputSequence.combineWith(this.socket.sequenceInput)
    }
  }
}